import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'lokos-change-geolovel-chip',
    standalone: false,
    templateUrl: './change-geolovel-chip.component.html',
    styleUrl: './change-geolovel-chip.component.scss'
})
export class ChangeGeolovelChipComponent {
    @Input() selectedState?: string | null;
    @Input() selectedDistrict?: string | null;
    @Input() selectedBlock?: string | null;
    @Input() selectedPanchayat?: string | null;
    @Input() selectedVillage?: string | null;
    @Input() selectedVO?: string | null;
    @Input() selectedSHG?: string | null;
    @Input() selectedCLF?: string | null;
    @Input() selectedBankType?: string | null;
    @Input() selectedBankName?: string | null;
    @Input() selectedPromoter?: string | null;
    @Input() selectedCadreVertical?: string | null;
    @Input() activeGeoLevel!: number;

    @Output() goBack = new EventEmitter<number>();

    onBackClick() {
        this.goBack.emit(this.activeGeoLevel);
    }
}
